import ArchivioAreeTematiche from './ArchivioAreeTematiche';

export default ArchivioAreeTematiche;
